import { useState } from 'react'
import { ScanCardTab } from '../components/ScanCardTab'
import { ScanCardLive } from '../components/ScanCardLive'
import { cn } from '@/lib/utils'

type ScanMode = 'upload' | 'live'

export function ScanPage() {
  const [mode, setMode] = useState<ScanMode>('upload')
  const [cameraActive, setCameraActive] = useState(false)

  const hideModeSelector = mode === 'live' && cameraActive

  const setModeUpload = () => {
    setMode('upload')
    setCameraActive(false)
  }

  return (
    <div className="space-y-4 sm:space-y-6">
      {!hideModeSelector && (
      <div className="flex gap-1 sm:gap-2 p-1 bg-gray-100 rounded-lg w-full sm:w-fit">
        <button
          type="button"
          onClick={setModeUpload}
          className={cn(
            'flex-1 sm:flex-initial min-h-[44px] sm:min-h-0 px-4 py-3 sm:py-2 rounded-md text-sm font-medium transition-colors touch-manipulation',
            mode === 'upload' ? 'bg-white text-gray-900 shadow-sm' : 'text-gray-600 hover:text-gray-900 active:bg-gray-200/50'
          )}
        >
          Upload / Photo
        </button>
        <button
          type="button"
          onClick={() => setMode('live')}
          className={cn(
            'flex-1 sm:flex-initial min-h-[44px] sm:min-h-0 px-4 py-3 sm:py-2 rounded-md text-sm font-medium transition-colors touch-manipulation',
            mode === 'live' ? 'bg-white text-gray-900 shadow-sm' : 'text-gray-600 hover:text-gray-900 active:bg-gray-200/50'
          )}
        >
          Live camera
        </button>
      </div>
      )}

      {mode === 'upload' && <ScanCardTab />}
      {mode === 'live' && <ScanCardLive onCameraActiveChange={setCameraActive} />}
    </div>
  )
}
